<mat-toolbar class="subtitulo">Atendimento e Visitas</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-label fxFlexOffset="20px">Selecione um atendimento</mat-label>
                    <mat-select fxFlexOffset="20px" [(ngModel)]="atendimento" name="atendimento">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of atendimentos" [value]="d">
                            {{ d.dataAtendimento | dataSimples}} - {{ d.aluno.pessoaFisica.nome }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="DataAtendimento">
                <th mat-header-cell *matHeaderCellDef> Data de Atendimento: </th>
                <td mat-cell *matCellDef="let element"> {{element.dataAtendimento | dataSimples}} </td>
            </ng-container>


            <ng-container matColumnDef="Aluno">
                <th mat-header-cell *matHeaderCellDef> Beneficiário: </th>
                <td mat-cell *matCellDef="let element"> {{element.aluno?.pessoaFisica.nome}} </td>
            </ng-container>

            <ng-container matColumnDef="Diagnostico">
                <th mat-header-cell *matHeaderCellDef> Diagnóstico: </th>
                <td mat-cell *matCellDef="let element"> {{element.diagnostico?.descricao }} </td>
            </ng-container>

            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
            style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar novo atendimento" mat-fab color="primary"
                    [routerLink]="['/atendimento/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>